module.exports = "/assets/ff997299873abccc9ee62b45af2009fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/WW.png
// module id = 3094
// module chunks = 0